import { withDeadline } from "@-/dev.improve.haniverse.lib.deadline";
import { getDeviceSetting } from "@-/dev.improve.haniverse.lib.device-settings";
import { getOrpcClient } from "@-/dev.improve.haniverse.lib.orpc";

/** One small request; nothing waits on it, so it never outlives a network bound. */
const ACKNOWLEDGE_DEADLINE_MS = 20_000;

/**
 * The install id the server knows this device by, or `undefined` when it never registered for
 * sync pushes (web, a build without push support, or before the first registration). Passed to
 * `sync.notify` so the sender is not pushed about its own upload.
 */
export function getRegisteredSyncPushDeviceId(): string | undefined {
  return getDeviceSetting("syncPushRegistration")?.deviceId;
}

/**
 * Tell the server this device caught up with the cloud, so the next upload from another device
 * pushes it again (the server pushes each device once per stretch of being behind). A device that
 * never registered is never pushed, so it has nothing to acknowledge.
 */
export async function acknowledgeSyncPush(): Promise<void> {
  const deviceId = getRegisteredSyncPushDeviceId();
  if (deviceId === undefined) {
    return;
  }
  await withDeadline({ deadline: ACKNOWLEDGE_DEADLINE_MS, operation: "sync.acknowledgePush" }, () =>
    getOrpcClient.sync.acknowledgePush({ deviceId }),
  );
}
